import api from '../../redux/api';
import { CASHIER_V1_BASE, CASHIER_POS_BASE } from './constants';

export const sellerCashierPosService = {
  processTransaction: async (transactionData) => {
    const { type, amount, points, voucher_id, description, receipt_no, products } = transactionData;
    const customerPk =
      transactionData.customer_id ??
      transactionData.customerId;

    if (type === 'earn') {
      const response = await api.post(`${CASHIER_V1_BASE}/points/earn`, {
        customerId: customerPk,
        customer_id: customerPk,
        total: amount,
        points: points,
        description: description || `Points earned from ${amount} purchase`,
        receipt_no: receipt_no,
        products: products && products.length ? products : undefined
      });
      return response.data;
    } else if (type === 'redeem') {
      const response = await api.post(`${CASHIER_V1_BASE}/vouchers/redeem`, {
        customerId: customerPk,
        customer_id: customerPk,
        voucherId: voucher_id,
        voucher_id: voucher_id,
        description: description || 'Points redeemed'
      });
      return response.data;
    } else {
      throw new Error('Invalid transaction type');
    }
  },

  searchCashierCustomers: async (params = {}) => {
    const response = await api.get(`${CASHIER_V1_BASE}/customers`, {
      params: {
        search: params.search,
        page: params.page,
        limit: params.limit
      }
    });
    return response.data?.data || response.data;
  },

  createCashierCustomer: async (customerData) => {
    const response = await api.post(`${CASHIER_V1_BASE}/customers`, customerData);
    return response.data?.data || response.data;
  },

  getCustomerBalance: async (customerId) => {
    const response = await api.get(`${CASHIER_POS_BASE}/customers/${customerId}/balance`);
    return response.data?.data || response.data;
  },

  getCashierCustomerTransactions: async (customerId, params = {}) => {
    const response = await api.get(`${CASHIER_POS_BASE}/customers/${customerId}/transactions`, { params });
    return response.data?.data || response.data;
  },

  getRewardsCatalog: async (params = {}) => {
    const response = await api.get(`${CASHIER_V1_BASE}/rewards/catalog`, { params });
    return response.data?.data || response.data;
  },

  processVoidReturn: async (voidData) => {
    const response = await api.post(`${CASHIER_POS_BASE}/points/reverse`, {
      transactionId: voidData.transactionId,
      reason: voidData.reason
    });
    return response.data?.data || response.data;
  },

  processRefund: async (refundData) => {
    const response = await api.post(`${CASHIER_POS_BASE}/vouchers/refund`, {
      voucherId: refundData.voucherId,
      reason: refundData.reason
    });
    return response.data?.data || response.data;
  },

  updateCustomerProfile: async (customerId, profileData) => {
    const response = await api.put(`${CASHIER_POS_BASE}/customers/${customerId}`, profileData);
    return response.data?.data || response.data;
  },

  exportCashierTransactions: async (params = {}) => {
    const response = await api.get(`${CASHIER_V1_BASE}/transactions/export`, {
      params,
      responseType: 'blob',
    });
    return response.data;
  },

  getCustomerTransactionHistory: async (customerId, params = {}) => {
    return sellerCashierPosService.getCashierCustomerTransactions(customerId, params);
  },

  getCashierTransactions: async (params = {}) => {
    const response = await api.get(`${CASHIER_V1_BASE}/transactions`, { params });
    return response.data?.data || response.data;
  },
};

export default sellerCashierPosService;
